import React from 'react';
import cn from 'classnames';
export default function PaymentIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    style = _ref.style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    className: cn('icons', className),
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    width: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.118 15.5983V15.4372H20.1921V15.4039H20.0158V15.4372H20.0854V15.5983L20.118 15.5983ZM20.4602 15.5983V15.4039H20.4068L20.3446 15.5427L20.2824 15.4039H20.2291V15.5983H20.2676V15.4511L20.3254 15.5775H20.3654L20.4231 15.4511V15.5983H20.4602Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4342 8.56912H14.568V16.4301H9.4342V8.56912Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96297 12.5003C9.96234 11.7434 10.1454 10.9962 10.4982 10.3154C10.8511 9.63455 11.3645 9.03788 11.9996 8.57053C11.213 7.99095 10.2683 7.63054 9.27348 7.5305C8.27869 7.43046 7.27394 7.59482 6.37408 8.00479C5.47421 8.41477 4.71552 9.05381 4.18474 9.8489C3.65395 10.644 3.37247 11.563 3.37247 12.501C3.37247 13.439 3.65395 14.358 4.18474 15.1531C4.71552 15.9482 5.47421 16.5872 6.37408 16.9972C7.27394 17.4072 8.27869 17.5715 9.27348 17.4715C10.2683 17.3715 11.213 17.0111 11.9996 16.4315C11.3643 15.964 10.8507 15.3671 10.4979 14.686C10.145 14.0049 9.96211 13.2575 9.96297 12.5003V12.5003Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6276 12.5003C20.6275 13.4384 20.346 14.3575 19.8151 15.1526C19.2842 15.9477 18.5254 16.5867 17.6254 16.9966C16.7254 17.4066 15.7206 17.5708 14.7257 17.4706C13.7309 17.3704 12.7862 17.0098 11.9996 16.4301C12.6345 15.9623 13.1478 15.3655 13.5007 14.6846C13.8536 14.0037 14.037 13.2566 14.037 12.4996C14.037 11.7426 13.8536 10.9955 13.5007 10.3146C13.1478 9.63373 12.6345 9.0369 11.9996 8.56914C12.7862 7.98937 13.7309 7.62879 14.7258 7.5286C15.7206 7.42841 16.7255 7.59266 17.6254 8.00258C18.5254 8.4125 19.2842 9.05154 19.8151 9.84666C20.346 10.6418 20.6275 11.5609 20.6276 12.4989V12.5003Z",
    fill: "#F79E1B"
  })));
}